import React from 'react';

export const getHandleFieldChange = (setFormState: (state: any) => void) => {

  return (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    event.persist();
    setFormState((oldState: any) => {
      let value: any = event.target.type === 'checkbox' ? (event.target as HTMLInputElement).checked : event.target.value;
      switch (typeof oldState[event.target.name]) {
        case 'number':
          if (isNaN(value)) {
            value = 0;
          } else {
            value = Number(value);

          }
          break;
        case 'boolean':
          value = Boolean(value);
          break;
      }
      return ({
        ...oldState,
        [event.target.name]: value
      })
    });
  };
};

export const getHandleMultiFieldChange = (setFormState: (state: any) => void) => {
  return (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    setFormState((oldState: any) => {
      const regex = /([^\[]*)\[([0-9])]/g;
      const nameArr = regex.exec(event.target.name);
      if (nameArr) {
        const name = nameArr[1];
        const index = Number(nameArr[2]);

        if (name && !isNaN(index)) {
          const oldValue: number[] = (oldState as { [key: string]: any })[name]!;
          if (oldValue) {
            const value = event.target.checked ? [...oldValue, index] : oldValue.filter(num => num !== index)
            setFormState({...oldState, [name]: value});
          }
        }
      }
    });
  };
};

export const getHasError = (errors: { errors: any }) => {

  return (fieldName: string) => {
    // @ts-ignore
    const foundError = !!errors.errors[fieldName];
    return {
      error: foundError,
      // @ts-ignore
      helperText: foundError ? errors.errors[fieldName]![0] : '',
    };
  };
};
